import {
  SET_PRODUCT,
  SET_PLUGIN_INFO,
  SET_BRIEFS,
  SET_BRIEFS_LOADING,
  SET_ADOBE_RATING,
  SET_RATING_LOADING,
  SET_RATING_PAGINATION,
  SET_RATING_PREVIEW,
  SET_RATING_HISTORY,
} from './product.constants';


const initialState = {
  briefs: [],
  briefsLoading: false,
  product: {},
  pluginInfo: {},
  adobeRating: [],
  ratingLoading: false,
  ratingPagination: 1,
  // true — бэкенд отдал урезанную витрину (нет доступа adobe): фильтры и сортировка бессмысленны.
  // true до первого ответа сервера: пока доступ неизвестен, считаем выдачу урезанной.
  // С false фильтры успевали отрисоваться на первом кадре и исчезали, когда приходил ответ
  // с isPreview: true — то самое «мелькнули и пропали».
  ratingPreview: true,
  // Суточные срезы одной выдачи для графика, от старых к новым.
  ratingHistory: [],
};

const productReducer = (state = initialState, action) => {
  const { type, payload = {} } = action;

  switch (type) {
    case SET_BRIEFS: {
      return {
        ...state,
        briefs: payload,
      }
    }

    case SET_BRIEFS_LOADING: {
      return {
        ...state,
        briefsLoading: payload,
      }
    }

    case SET_PRODUCT: {
      return {
        ...state,
        product: payload,
      }
    }

    case SET_PLUGIN_INFO: {
      return {
        ...state,
        pluginInfo: payload,
      }
    }

    case SET_ADOBE_RATING: {
      return {
        ...state,
        // Всегда массив: RatingList зовёт .map, а payload по умолчанию равен {} — если экшен
        // прилетит без данных (пустой/неожиданный ответ API), таблица упала бы на рендере.
        adobeRating: Array.isArray(payload) ? payload : [],
      }
    }

    case SET_RATING_PREVIEW: {
      return {
        ...state,
        ratingPreview: !!payload,
      }
    }

    case SET_RATING_HISTORY: {
      return {
        ...state,
        ratingHistory: Array.isArray(payload) ? payload : [],
      }
    }

    case SET_RATING_LOADING: {
      return {
        ...state,
        ratingLoading: payload,
      }
    }

    case SET_RATING_PAGINATION: {
      return {
        ...state,
        ratingPagination: payload,
      }
    }

    default:
      return state;
  }
};

export default productReducer;
